import * as types from './mutation-types';
import API from '@/services/commonApi';
import { SHCUSTOMERS, SHBROKERS, SHPROJECTS, PROJECTRMDETAILS, BROKERLISTWITHDRM, EDITDRM, UPDATERMSTATUS } from '@/utils/endpoint';
import store from '@/store';

const actions = {
  getMyCustomers: ({ commit }, payload) => {
    API.get(`${SHCUSTOMERS}${payload.id}/`)
      .then((response) => {
        commit(types.MYCUSTOMERS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getMyProjects: ({ commit }, payload) => {
    API.get(`${SHPROJECTS}${payload.id}/`)
      .then((response) => {
        commit(types.MYPROJECTS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getMyBrokers: ({ commit }, payload) => {
    API.get(`${SHBROKERS}${payload.id}/`)
      .then((response) => {
        commit(types.MYBROKERS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getBrokersWithDrms: ({ commit }) => {
    API.get(BROKERLISTWITHDRM)
      .then((response) => {
        commit(types.BROKERLISTWITHDRM, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  editDrm: ({ _commit }, payload) => {
    API.post(EDITDRM, payload.data)
      .then(() => {
        if (payload.cbSuccess)
          payload.cbSuccess();
        // commit(types.ADDRMTOPROJECT, response);
      })
      .catch((error) => {
        console.log(error);
        if (payload.cbError)
          payload.cbError();
      });
  },
  addRmToProject: ({ _commit }, payload) => {
    API.post(`${PROJECTRMDETAILS}${payload.projectId}/`, { rm_id: payload.rmId })
      .then(() => {
        store.dispatch('users/getRmDetails', { id: payload.projectId });
        if (payload.cbSuccess)
          payload.cbSuccess();
        // commit(types.ADDRMTOPROJECT, response);
      })
      .catch((error) => {
        console.log(error);
        if (payload.cbError)
          payload.cbError();
      });
  },
  removeRmFromProject: ({ _commit }, payload) => {
    API.delete(`${PROJECTRMDETAILS}${payload.projectId}/`, payload.rmId)
      .then(() => {
        store.dispatch('users/getRmDetails', { id: payload.projectId });
        // commit(types.REMOVERMFROMPROJECT, response);
      })
      .catch((error) => {
        console.log(error);
        if (payload.cbError)
          payload.cbError(error);
      });
  },
  changeRMStatus: ({ _commit }, payload) => {
    API.put(UPDATERMSTATUS, { id: payload.rmId })
      .then(() => {
        store.dispatch('users/getRmDetails', { id: payload.projectId });
      })
      .catch((error) => {
        console.log(error);
        if (payload.cbError)
          payload.cbError(error);
      });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/saleshead/actions.js